import ListTag from './ListTag.jsx'
import {ethers} from 'ethers'
import {useEffect, useState} from "react";
import AddressToAccount from "../../../../components/AddressToAccount/index.jsx";
import Web3 from "web3";
import dateformat from 'dateformat';
//import chainData from "../chains";

let abi = [
    'function getTokenSaleHistory(address, uint256) view returns (uint256 c)',
    'function auctionHistory(address, uint256, uint256) view returns(bool,uint256,address,address,uint256,uint256,uint256,uint256,bool,bytes32,uint256,uint256,uint256)'
]

/**
 * SectionHistory component.
 *
 * Displays the complete sale/activity history for an item.
 * Shows:
 * - Total number of sales
 * - List of all past events (sales, bids, removals) with:
 *   - Bidder address
 * - Timestamp formatted as date/time
 * - Bid amount in native token
 *
 * Fetches history from AuctionManager contract using
 * getTokenSaleHistory and auctionHistory methods.
 *
 * @param {Object} props - Component props
 * @param {Object} props.data - Collection data (unused)
 * @param {Object} props.ti - Token/item information with contract and chain data
 * @returns {React.ReactElement} Sale history card or null
 */
function SectionHistory({data, ti}) {

    let udctr = 1;

    let [sales, sSales] = useState(0)
    const [su, ssu] = useState(0)
    let [hist, sHist] = useState([])
    const [udh, sUdh] = useState(0)
    const [ctok, sCtok] = useState()
    const [out, sout] = useState()

    let tid = ti?.bcd?.tid;

    let htemp = []

    let w3p;
    let contract;

    // useEffect( () => {
    //     //sUdh(udctr)
    //
    //     //sSales(null)
    //     getHist();
    //
    // }, [])

    useEffect( () => {
        //sUdh(udctr)
        sout(null);
        udctr++;
        sUdh(udctr)
        //sSales(null)
        getHist();

    }, [ti])

    async function getBids(aid){
    }

    async function getHist() {
        while (!ti.bcd) {
            await new Promise(r => setTimeout(r, 50));
        }
        if (ti && data && ti?.bcd?.chainInf) {

            //if (ctok !== ti.bcd.tid) {
                try {
                    w3p = new ethers.providers.JsonRpcProvider(ti.bcd.chainInf.rpc)
                    contract = new ethers.Contract(ti.bcd.chainInf.aManager, abi, w3p);
                    let moo = await contract.getTokenSaleHistory(ti.bcd.contract, ti.bcd.tid);
                    let _sales = parseInt(moo.toString());
                    sSales((moo).toString())
                    ssu(udctr)
                    sHist([])
                    htemp = []
                    for (let i = (_sales - 1); i > -1; i--) {

                        let resp = await contract.auctionHistory(ti.bcd.contract, ti.bcd.tid.toString(), i.toString())
                        htemp.push([resp])
                        //hist=htemp;

                        //udctr++;
                        //sUdh(udctr)

                        sCtok(ti.bcd.tid);
                    }
                    udctr++;
                    sUdh(udctr)
                    sout (<>
                        {htemp.length ? <>
                            {htemp && htemp.map((item, i) => (
                                    <>{console.log("aaa", item)}
                                        <> {
                                            new Date(parseInt(item[0][7]) * 1000).toString() !== "Invalid Date" &&
                                            !(new Date(parseInt(item[0][7]) * 1000).toString()).includes("Jan 01 1970") ?
                                                <AddressToAccount onClick={()=>getBids(parseInt(item[0][1]))}
                                                    address={item[0][2]}
                                                    flags={"bob"}
                                                    title2={<>{(item[0][8] === true ? "Buy Now" : "Auction")}<br/>{
                                                        Web3.utils.toAscii(item[0][9])
                                                            .replace("RemovedBySeller", "Seller Removed")
                                                    }</>}
                                                    comment={
                                                        <div style={{
                                                            flex: 1,
                                                            alignSelf: "end",
                                                            textAlign: "right",
                                                            position: "relative",
                                                            right: 0
                                                        }}>
                                                            Bid: {parseFloat(ethers.utils.formatEther(item[0][4].toString())).toFixed(2)}<br/>
                                                            <span
                                                                className={"text-xs text-bold"}>{
                                                                dateformat(new Date(parseInt(item[0][7]) * 1000).toString(), "hh:mm\ndd/mm/yy")}</span>
                                                        </div>}
                                                />
                                                : <></>} </>

                                    </>


                                )
                            )
                            } </> : null}
                    </>)
                } catch (e) {
                    sout(null);
                }
          //  }
        } else {
            sout(null);
        }
    }

    // useEffect(async ()=>{
    //
    //     if(ti && data && ti?.bcd?.chainInf) {
    //         // get the auction datas
    //         w3p = new ethers.providers.JsonRpcProvider(ti.bcd.chainInf.rpc)
    //         contract = new ethers.Contract(ti.bcd.chainInf.aManager, abi, w3p);
    //
    //             console.log("HIST", hist);
    //             console.log("HTMP", htemp)
    //         }
    //
    //     }
    // }, [su])

    useEffect(() => {
    }, [udh])

    return (
        <>
            {sales && sales > 0 ?
                <div style={{flex:1, flexGrow: 1}}>
                    <div className="card card-purple mb-2">
                        <div className="card-body p-3">
                            <h6 className="mb-0 text-light text-bolder">Sale History ({sales})</h6>
                            {/*<ul className="border-0">*/}
                            {out}

                        </div>
                    </div>
                </div>
                : null}
        </>
    )
}
export default SectionHistory
